/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import omitBy from 'lodash/omitBy';
import { colorsPalette } from '../../../styles/colors';
import { SafePureComponent } from '../../../utils/SafePureComponent';

const getBackgroundAndColor = backgroundColor => {
  const color =
    typeof backgroundColor === 'object'
      ? get(backgroundColor, 'fields.Value.value', 'transparent')
      : backgroundColor;

  const selectedColor = colorsPalette[color] || 'transparent';

  const backgroundCss = css({
    backgroundColor: selectedColor,
  });

  return [backgroundCss, selectedColor];
};

class Spacer extends SafePureComponent {
  safeRender() {
    const {
      id,
      backgroundColor,
      children = [],
      marginCss = {},
      paddingCss = {},
      customCss = {},
      containerProps = {},
    } = this.props;

    const [backgroundCss, color] = getBackgroundAndColor(backgroundColor);
    const spacerCss = color === 'transparent' ? marginCss : paddingCss;
    const sectionProps = omitBy(containerProps, value => value === false);

    return (
      <section
        id={id}
        {...sectionProps}
        css={[backgroundCss, spacerCss, customCss]}
      >
        {children}
      </section>
    );
  }
}

Spacer.displayName = 'Spacer';

Spacer.propTypes = {
  id: PropTypes.string,
  backgroundColor: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  children: PropTypes.node,
  marginCss: PropTypes.any,
  paddingCss: PropTypes.any,
  customCss: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  containerProps: PropTypes.object,
};

export default Spacer;
